import React from "react";
import { useAnimation, motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import Customers from "./Customers";

export default function About() {
  const control = useAnimation();
  const [ref, inView] = useInView();

  const variantBuild = (i) => {
    return {
      visible: {
        opacity: 1,
        y: 0,
        transition: { delay: 0.3 * i, duration: 0.5 },
      },
      hidden: { opacity: 0, y: 100 },
    };
  };

  React.useEffect(() => {
    if (inView) {
      control.start("visible");
    } else {
      control.start("hidden");
    }
  }, [control, inView]);

  return (
    <section className="pt-[78px] relative z-10 bg-[#114F94]" id="about-us">
      {/* About Us */}
      <div className="relative flex gap-10 mb-12 p-6" ref={ref}>
        <div>
          <motion.h2
            className="text-3xl font-bold text-default mb-4"
            animate={control}
            initial="hidden"
            variants={variantBuild(0)}
          >
            About Us
          </motion.h2>
          <motion.div
            animate={control}
            initial="hidden"
            variants={variantBuild(1)}
            className="p-8 rounded-md text-default w-full sm:w-[600px] md:w-[700px] lg:w-[800px] bg-[#072E6F]/40"
          >
            <p>
              PT Surya Bintang Cemerlang was founded in 2012. This company is a transportation service company that
              connects ship and cargo owner to facilitate transport of bulk cargo by sea.
            </p>
            <br />
            <p>
              We provide tug and barge ships to carry bulk cargo that mostly consists of mining products, particularly
              coal and nickel ore. We have varieties of barge ships for you to choose.
            </p>
          </motion.div>
        </div>
        <motion.div
          animate={control}
          initial="hidden"
          variants={variantBuild(1)}
          className="hidden lg:flex justify-center items-center w-full relative"
        >
          <div className="w-full h-full absolute bottom-0 bg-white blur-md rounded-xl opacity-80"></div>
          <img className="relative z-10 w-[400px]" src="images/best_logo.png" alt="Logo" />
        </motion.div>
      </div>

      <Customers />
    </section>
  );
}
